import React from 'react';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import globalStyles from '../styles';

const PageBase = (props) => {

    const {title, sub, navigation} = props;

    return (
      <div>

        <Paper style={globalStyles.paper}>
          <div style={{display: "flex", justifyContent: "space-between"}}>
            <h3 style={globalStyles.title}>{title}</h3>
            {sub}
          </div>
          <Divider/>
          {props.children}

          <div style={globalStyles.clear}/>

        </Paper>
      </div>
    );
};

export default PageBase;



// WEBPACK FOOTER //
// ./src/components/PageBase.js